import "./InputField.css";
import Dropdown from "../Dropdown/Dropdown";

const InputField = ({
  name,
  placeholder,
  onChange,
  value,
  style,
  type = "text",
  options = [],
  onDropdownChange,
  dropdownPlaceholder,
  dropdownValue,
  onBlur,
  onKeyDown,
  autoComplete = true,
  maxLength
}) => {
  return (
    <div className="custom-input-wrapper" style={style}>
      <input
        autoComplete={autoComplete}
        autoCorrect={autoComplete}
        type={type}
        name={name}
        className="custom-input"
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        style={style}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        maxLength={maxLength}
      />
      {onDropdownChange && (
        <Dropdown
          style={{ marginRight: "2px" }}
          options={options?.map((option) => ({
            value: option.value,
            label: option.label,
          }))}
          placeholder={dropdownPlaceholder}
          onChange={onDropdownChange}
          value={dropdownValue}
        />
      )}
    </div>
  );
};

export default InputField;
